import { ChangeDetectionStrategy, Component, EventEmitter, Output, inject } from '@angular/core';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { ICartItem } from '../../../cart/core/interfaces/ICartItem';
import { IGroupedShow } from '../../../cart/core/interfaces/IGroupedShow';
import { groupCartTicketsByShow } from '../../../cart/core/utils/groupCartTicketsByShow';
import { CartStore } from '../../../cart/core/stores/CartStore';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { LocaleDatetimeFormatPipe } from '../../../../shared/pipes/locale-datetime-format.pipe';
import { NumberToCurrencyPipe } from '../../../../shared/pipes/number-to-currency.pipe';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';

@Component({
  selector: 'app-external-voucher-ticket-picker-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    NumberToCurrencyPipe,
    LocaleDatetimeFormatPipe
  ],
  templateUrl: './external-voucher-ticket-picker-modal.component.html',
  styleUrl: './external-voucher-ticket-picker-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExternalVoucherTicketPickerModalComponent extends BaseModalComponent<ICartItem[]> {

  @Output() public ticketSelected = new EventEmitter<ICartItem>();

  public readonly cartStore = inject(CartStore);

  public selectedTicket: ICartItem | null = null;

  public get groupedShows(): IGroupedShow[] {
    return groupCartTicketsByShow(this.data ?? []);
  }

  public override open(tickets: ICartItem[]): void {
    this.selectedTicket = null;
    super.open(tickets);
  }

  public selectTicket(ticket: ICartItem): void {
    this.selectedTicket = ticket;
    this.cdr.markForCheck();
  }

  public confirm(): void {
    if (!this.selectedTicket) {
      return;
    }
    this.ticketSelected.emit(this.selectedTicket);
    this.close();
  }
}
